import regulationspolicy from "../../apis/regulationPolicy";
export default {
  createRegulations({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await regulationspolicy.createRegulations(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getRegulations({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await regulationspolicy.getRegulations(payload);
        commit("GET_REGULATIONS_POLICY", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  deleteRegulations({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await regulationspolicy.deleteRegulations(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  editRegulations({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await regulationspolicy.editRegulations(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
